import axios from 'axios'

export default class TierService {
  public getAll() {
    return axios.get('/api/v1/tiers/')
  }
}
